import PDFDocument from 'pdfkit/js/pdfkit.standalone.js';
import {
	cmToPoint,
	getQuoteTableColWidths,
	renderAddress,
	renderDetails,
	renderFooter,
	renderHeader,
	renderQuoteTable,
	renderSummaryTable,
	renderTitle
} from './helpers/index';
import { COLOR_BLACK, FONT, FONT_SIZE_NORMAL, FONT_SIZE_SMALL, SPACE, SPACE2 } from './variables';

export async function createQuotePdf(body: any, afterInit: (pdf: PDFDocument) => Promise<void>) {
	// create a document and pipe to a blob
	const pdf = new PDFDocument({
		bufferPages: true,
		layout: 'portrait',
		size: 'A4',
		margins: {
			top: cmToPoint(1.27),
			bottom: cmToPoint(1.27),
			left: cmToPoint(2),
			right: cmToPoint(1.27)
		}
	});

	await afterInit(pdf);

	await renderHeader(pdf, body);
	renderAddress(pdf, body);
	renderTitle(pdf, body);
	renderDetails(pdf, body);

	pdf.y += cmToPoint(SPACE);

	for (const product of body.products) {
		await renderQuoteTable(pdf, product.header, product.items);
	}

	const { colDescription } = getQuoteTableColWidths(pdf, body.products.filter(o => o.items.image).length > 0);

	renderSummaryTable(pdf, body, colDescription);
	renderShippingAddress(pdf, body);
	renderComments(pdf, body);
	renderFooter(pdf, body);

	return pdf;
}

function renderShippingAddress(pdf: PDFDocument, body: any) {
	if (!body.hasDifferentShippingAddress) {
		return;
	}
	if (!body.shippingAddress) {
		return;
	}

	let items: string[] = [];

	const address = body.shippingAddress;

	if (address.company) {
		items.push(address.company);
	}

	if (address.name) {
		items.push(address.name);
	}

	if (address.address1) {
		items.push(address.address1);
	}

	if (address.address2) {
		items.push(address.address2);
	}

	if (address.zipCode || address.city) {
		items.push(`${address.zipCode} ${address.city}`.trim());
	}

	if (address.country) {
		items.push(address.country);
	}

	items = items.filter(i => i && i.trim() !== '');

	if (!items.length) {
		return;
	}

	pdf.y += cmToPoint(SPACE * 2);

	pdf.fontSize(FONT_SIZE_NORMAL).font(FONT).fillColor(COLOR_BLACK);

	pdf.text(body.shippingAddress.label, {
		lineGap: 1.65
	});

	pdf.fontSize(FONT_SIZE_SMALL).font(FONT);

	for (let i = 0; i < items.length; i++) {
		if (i > 0 && i < items.length) {
			pdf.y += SPACE2;
		}

		pdf.text(items[i]);
	}
}

function renderComments(pdf: PDFDocument, body: any) {
	if (!body.comments?.value) {
		return;
	}

	pdf.y += cmToPoint(SPACE * 2);

	pdf.fontSize(FONT_SIZE_NORMAL).font(FONT).fillColor(COLOR_BLACK);

	pdf.text(body.comments.label, {
		lineGap: 1.65
	});

	pdf.fontSize(FONT_SIZE_SMALL).font(FONT);

	pdf.text(body.comments.value, {
		lineGap: 1.65
	});
}
